let ytPlayer = null

/**
 * YouTube APIをロードする関数
 */
export const youtubeApiLoad = () => {
    return new Promise((resolve, reject) => {
      // YouTube APIスクリプトが既に存在するか確認
      if (window.YT && window.YT.Player) {
        resolve(window.YT);
        return;
      }

      // APIの読み込み完了を検知するためのコールバック
      window.onYouTubeIframeAPIReady = () => {
        resolve(window.YT);
      };

      // APIスクリプトをページに追加
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    });
}

/**
 * YouTubeプレーヤーを作成する関数
 * @returns {Object} YouTubeプレーヤーオブジェクト
 */
export const createYoutubePlayer = (playerId) => {
  const ytParam = {
    // videoId: "U9tukiDehH4",
    events: {
        'onReady': onPlayerReady,
        'onStateChange': onPlayerStateChange
    },
    playerVars: {
        'loop': 1,
        autoplay: 0,
        controls: 0,
        showinfo:0,
        rel: 0,
    }
  }
    const player = new window.YT.Player(playerId, {
      ...ytParam
    });
  return player;
}

/**
 * YouTubeプレーヤーの再生内容を変更する関数
 * @param {string} id - YouTubeビデオのID
 */
export const changeYoutubePlayer = (id) => {
  if (ytPlayer === null) {
    ytPlayer = createYoutubePlayer()
  }
  ytPlayer.loadVideoById(id, 0)
}

/**
 * YouTubeプレーヤーの再生を停止する関数
 */
export const stopYoutubePlayer = () => {
  ytPlayer.pauseVideo()
}

/**
 * YouTubeの初期化を行う関数
 */
export const initYoutube = (playerId='v-modal-video') => {
  youtubeApiLoad()
  window.onYouTubeIframeAPIReady = () => {
    ytPlayer = createYoutubePlayer(playerId)
  }
}
const onPlayerReady = (e) => {
  e.target.pauseVideo();
}

const onPlayerStateChange = (event) => {
    const state = event.target.getPlayerState();
    if(state === 5) {
      event.target.playVideo()
    }
}

export const youtubeLoad = (videoId) => {
    players.forEach((player) => {
        player.cueVideoById({ videoId: videoId, startSeconds: 0 });
        player.playVideo();
    })
}
export const handlePlayButtonClick = () => {
    players.forEach((player) => {
        player.playVideo();
    });
};